/*!
 * Floating Labels
 */
var $ = require('jquery');

$(function() {
	var formFloatingLabel = function () {
		var FL_onClass = 'control-label--on',
				FL_showClass = 'control-label--show';

		$('.form-group--floating-label .form-control')
				.bind('checkval', function() {
					var label = $(this).prev('.control-label');
					if (this.value !== '') {
						label.addClass(FL_showClass);
					} else {
						label.removeClass(FL_showClass);
					}
				})
				.on('keyup', function() {
					$(this).trigger('checkval');
				})
				.on('focus', function() {
					$(this).prev('.control-label').addClass(FL_onClass);
				})
				.on('blur', function() {
					$(this).prev('.control-label').removeClass(FL_onClass);
				})
				.on('change', function() {
					$(this).trigger("checkval");
				})
				.trigger('checkval');

		$('.form-group--floating-label-typeahead .form-control')
				.bind('checkval', function() {
					var label = $(this).parent().parent().parent().find('.control-label');
					label.on('click', function() {
						var labelId = $(this).attr('for');
						$('#'+labelId+'_label').trigger('focus');
					});
					if (this.value !== '') {
						label.addClass(FL_showClass);
					} else {
						label.removeClass(FL_showClass);
					}
				})
				.on('keyup', function() {
					$(this).trigger('checkval');
				})
				.on('focus', function() {
					$(this).parent().parent().parent().find('.control-label').addClass(FL_onClass);
				})
				.on('blur', function() {
					$(this).parent().parent().parent().find('.control-label').removeClass(FL_onClass);
				})
				.on('change', function() {
					$(this).trigger("checkval");
				})
				.trigger('checkval');


/*
		$("select")
				.bind("checkval", function() {
					var label = $(this).prev("label");
					if (this.value !== "") {
						label.addClass(FL_showClass);
					} else {
						label.removeClass(FL_showClass);
					}
				})
				.on("change", function() {
					$(this).trigger("checkval");
				})
				.trigger("checkval");
*/

	}

	formFloatingLabel();

	$(document).on('afterContentsReplaced', function () {
		formFloatingLabel();
	})

});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/formFloatingLabels.js